// extracted by mini-css-extract-plugin
export default {"section":"components-hotel-short-term-rental-short-term-rental-breakdowns-module__section"};